import {
  INACTIVE_BILLING_SUBSCRIPTION_RESPONSE,
  type BillingCustomerPortalSessionResponse,
  type BillingCustomerSessionResponse,
  type BillingSubscriptionStatusResponse,
  type BillingUserUsageResponse,
} from '~~/shared/billing/contracts'

export async function fetchSubscriptionStatusViaBff(
  token?: string,
  options?: { forceRefresh?: boolean }
): Promise<BillingSubscriptionStatusResponse> {
  if (!token) {
    return INACTIVE_BILLING_SUBSCRIPTION_RESPONSE
  }

  try {
    return await $fetch<BillingSubscriptionStatusResponse>(
      '/api/billing/subscription-status',
      {
        method: 'GET',
        // background requests should not show error toast
        ignoreErrorToast: true,
        query: options?.forceRefresh ? { refresh: '1' } : undefined,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch {
    return INACTIVE_BILLING_SUBSCRIPTION_RESPONSE
  }
}

export async function createCustomerSessionViaBff(
  token: string
): Promise<BillingCustomerSessionResponse> {
  return await $fetch<BillingCustomerSessionResponse>(
    '/api/billing/customer-session',
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
}

export async function fetchUserUsageViaBff(
  token: string
): Promise<BillingUserUsageResponse> {
  return await $fetch<BillingUserUsageResponse>('/api/billing/user-usage', {
    method: 'GET',
    // background requests should not show error toast
    ignoreErrorToast: true,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export async function createCustomerPortalSessionViaBff(
  token: string
): Promise<BillingCustomerPortalSessionResponse> {
  if (!token) {
    throw new Error('Missing access token')
  }

  return await $fetch<BillingCustomerPortalSessionResponse>(
    '/api/billing/customer-portal-session',
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
}
